import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { AvGroup, AvInput, AvForm, AvRadioGroup, AvRadio, AvField } from 'availity-mobx-reactstrap-validation';
import { Label, FormGroup } from 'reactstrap';

import { darkGreyColor, lightGrey2Color } from 'js/config/style';
import { validatePhoneNumber, validateFullName, validateCheckoutName } from 'js/services/Regex';
import { default as FormState } from 'js/stores/pages/MyAccountPageState/UserDetails';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import AddressInput from 'js/components/common/AddressInput';
import AddressFeedback from 'js/components/common/AddressInput/AddressFeedback';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';

import Container from './Container';
import Title from './Title';
import UserLogoIcon from './UserLogoIcon';
import AppUser from 'js/stores/AppUser';
import userCountry from 'js/services/UserCountry';

@inject('page')
@observer
export default class EditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      avatarError: '',
      displayWarning: false
    };

    this.form = FormState.create(getSnapshot(this.props.state));
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit = () => {
    if (this.form.setWasSubmitted() && this.form.canSave) {
      this.form.save().then(user => {
        this.setState({ displayWarning: false });
        AppUser.setDetails(user);
        this.props.state.onComplete({
          user,
        });
      }).catch((e)=>{
        this.setState({ displayWarning: true });
      });

    }
  };

  inputOnChange = (e) => {
    this.form.user.setLogin(e.target.value);
    this.setState({ displayWarning: false });
  }

  render() {
    const form = this.form;
    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit}>
          <UserLogoIcon color={darkGreyColor} />
          <Title>Personal information</Title>

          <AvGroup>
            <Label for="name">Full name</Label>
            <AvInput
              type="text"
              name="name"
              id="name"
              value={form.user.name || ''}
              onChange={form.user.setName}
              placeholder="Your real name"
              required
              validate={validateFullName}
            />
          </AvGroup>

          <AvGroup>
            <Label for="checkout_name">Checkout name</Label>
            <AvInput
              type="text"
              name="checkout_name"
              id="checkout_name"
              value={form.user.login || ''}
              onChange={(e)=> this.inputOnChange(e)}
              placeholder="Your checkout name"
              required
              validate={validateCheckoutName}
            />
            {this.state.displayWarning &&
              <div style={{width:'100%',marginTop:'0.25rem',fontSize:'.875em',color:'#dc3545'}} ><small>Checkout name already exists</small></div>
            }
          </AvGroup>

          <AvGroup>
            <Label for="address2">Phone number</Label>
            <AvInput
              name="phone_number"
              id="phone_number"
              type={userCountry() === 'NG' ? 'text' : 'tel'}
              autoComplete="tel"
              placeholder="Enter your phone number"
              value={form.user.phone_number}
              onChange={form.user.setPhoneNumber}
              required
              validate={validatePhoneNumber}
            />
          </AvGroup>

          <Label>Notification method</Label><br/>
          <AvRadioGroup inline name="notification_method" required errorMessage="Pick a notification method option" defaultValue={form.user.notification_method}>
            <AvRadio
              type="radio"
              name="notification_method"
              value="whatsapp"
              label="Whatsapp"
              onChange={form.user.setNotificationMethod}
            />
            <AvRadio
              type="radio"
              name="notification_method"
              value="sms"
              label="SMS"
              onChange={form.user.setNotificationMethod}
            />
          </AvRadioGroup>

          <AvGroup>
            <AvInput type="hidden" name="notification_method" value="whatsapp" />
          </AvGroup>


          <FormGroup className={form.hasAddressError ? 'has-danger text-danger' : ''}>
            <Label for="address">Address</Label>
            <AddressInput
              name="address"
              id="address"
              showError={form.hasAddressError}
              address={form.user.address}
              onChange={form.user.address.setAddress}
              placeholder="Your street address"
            />
            <AddressFeedback>Please enter and then select your address.</AddressFeedback>
          </FormGroup>

          <AvGroup>
            <AvInput
              type="text"
              name="address2"
              id="address2"
              value={form.user.address.address2 || ''}
              onChange={form.user.address.setAddress2}
              placeholder="Apt/suite (optional)"
            />
          </AvGroup>

          <ErrorDisplay>{form.error}</ErrorDisplay>

          <SubmitRow>
            <Button isLoading={form.isSaving} autoFocus type="submit">
              Save
            </Button>
          </SubmitRow>
        </AvForm>
      </Container>
    );
  }
}
